import MentoringTeams from './MentoringTeams.vue';

export default MentoringTeams;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/views/teams/index.ts